import { AVATAR_SIZE } from "./constants/constants";
import axios from "axios";
import { devicesWithoutPlayIcon } from "./constants/images";
import { lazy } from "react";
import md5 from "md5";
import { oemValues } from "./constants/oem";
import qs from "qs";
import sharedErrorStyles from "./pages/components/shared.module.scss";

export function getQueryParam(name, fallback) {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const value = query[name];
  if ((value === null || value === undefined) && fallback !== undefined)
    return fallback;
  if (Array.isArray(value)) return value[0];
  return value;
}

export function isDeviceClickable(model) {
  return !devicesWithoutPlayIcon.includes(model);
}

export function getModelName(model, name) {
  if (name) return name;

  model = oemValues.modelNameMap[model] || model;

  // Prefix is only used when friendly name not specified
  // i.e. when we are expected to always return the model name
  if (typeof name === "undefined" && oemValues.modelPrefix) {
    return oemValues.modelPrefix + " " + model;
  } else {
    return model;
  }
}

export function scrollToFirstValidationError(elem) {
  const firstError = (elem || document).querySelector(
    `.${sharedErrorStyles.errorLabel}`
  );
  if (!firstError) return;
  firstError.scrollIntoView({ behavior: "smooth" });
}

export function generateGravatarUrl(email) {
  if (!email) email = "DUMMY_EMAIL_PLACEHOLDER";
  // If an image URL is used it must be publicly available;
  // won't work on localhost
  // https://www.gravatar.com/site/implement/images/
  const defaultAvatar = oemValues.customAvatar
    ? `${process.env.REACT_APP_BASE_URL}/default-avatar.png`
    : "mp";
  const hash = md5(email.trim().toLowerCase());
  const params = qs.stringify({ s: AVATAR_SIZE * 2, d: defaultAvatar });
  return `https://www.gravatar.com/avatar/${hash}?${params}`;
}

export function supportsZones(device) {
  return device?.zones[0] && device?.zones[0].hasOwnProperty("id");
}

// Returns a new control object, augmented with additional attributes
// for sectionId and (if supported) zoneId
export function controlWithExtractedIds(control, supportsZones) {
  const [firstControlIdNumber, secondControlIdNumber] = control.id.split("-");
  const extractedIds = supportsZones
    ? {
        zoneId: parseInt(firstControlIdNumber),
        sectionId: parseInt(secondControlIdNumber),
      }
    : { sectionId: parseInt(firstControlIdNumber) };

  return { ...control, ...extractedIds };
}

export function canShowMicroIcon(device) {
  return (
    oemValues.voiceCompatible.includes(device.model) &&
    process.env.REACT_APP_SHOW_MICRO_ICON === "true"
  );
}

export function canShowRefreshIcon(deviceData) {
  const statusWithoutRefreshIcon = [
    "unselected",
    "checking",
    "available",
    "licenseAssigned",
  ];

  return (
    deviceData.status && !statusWithoutRefreshIcon.includes(deviceData.status)
  );
}

export function hasDevicesWithPlayIcon(devices) {
  return devices?.some((device) => isDeviceClickable(device.model));
}

export function hasDevicesWithMicroIcon(devices) {
  return devices?.some((device) => canShowMicroIcon(device));
}

export function loadTestComponent(importFunction) {
  return process.env.NODE_ENV !== "production"
    ? lazy(importFunction)
    : () => null;
}

export async function getCountryFromIP() {
  try {
    const { data } = await axios.get("https://ipapi.co/country/");
    return data;
  } catch (err) {
    throw err;
  }
}
